import type { Option } from '../types';

export function Select({
  id,
  value,
  options,
  onChange,
  onBlur,
  error,
  placeholder = 'Select an option',
}: {
  id: string;
  value: string | number | null;
  options: Option[];
  onChange: (value: string | number) => void;
  onBlur: () => void;
  error: string | null;
  placeholder?: string;
}) {
  return (
    <select
      id={id}
      className="hsab-calc__select"
      value={value ?? ''}
      onChange={(e) => {
        const raw = e.target.value;
        const matched = options.find((o) => String(o.value) === raw);
        onChange(matched ? matched.value : raw);
      }}
      onBlur={onBlur}
      aria-invalid={!!error}
      aria-describedby={error ? `${id}-error` : undefined}
    >
      <option value="" disabled>
        {placeholder}
      </option>
      {options.map((opt) => (
        <option key={String(opt.value)} value={String(opt.value)}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}
